module.exports = __webpack_public_path__ + "static/img/hair_05.debcbd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/hair/thumbnail/hair_05.png
// module id = wvdk
// module chunks = 0